import { WishlistPage } from '../pages/WishlistPage';

export function ResponsiveWishlistPage() {
  return <WishlistPage />;
}
